<template>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>Tous les Produits</h4>
        <h6>Gérer vos Produits</h6>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <a
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Exporter Pdf"
          @click.prevent="$emit('export-pdf')"
          ><img src="@/assets/img/icons/pdf.svg" alt="img"
        /></a>
      </li>
      <li>
        <a
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Exporter Excel"
          @click.prevent="$emit('export-csv')"
          ><img src="@/assets/img/icons/excel.svg" alt="img"
        /></a>
      </li>
      <li>
        <a
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Imprimer"
          @click.prevent="$emit('print-table')"
          ><i data-feather="printer" class="feather-printer"></i
        ></a>
      </li>
      <li>
        <a
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Actualiser"
          @click.prevent="$emit('refresh')"
          ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
        ></a>
      </li>
      <li>
        <a
          ref="collapseHeader"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Collapse"
          @click="toggleCollapse"
        >
          <i data-feather="chevron-up" class="feather-chevron-up"></i>
        </a>
      </li>
    </ul>
    <div class="page-btn">
      <router-link to="/produits/ajouter-produit" class="btn btn-added"
        ><vue-feather type="plus-circle" class="me-2"></vue-feather>Ajouter un
        nouveau produit</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
  },
};
</script>
